module.exports = "/assets/images/9050f1b762c74d6e55db092675cc3444.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_sort.svg
// module id = +QhH
// module chunks = 0